const identiti2Routes = [
  {
    path: '/logincompany',
    nme: 'login',
    component: () => import(/* webpackChunName: "login" */ './views/Login.vue')
  },
  {
    path: '/login',
    nme: 'Verify',
    component: () => import(/* webpackChunName: "login" */ './views/VerifyOtp.vue')
  },
  {
    path: '/autoLogin',
    nme: 'login',
    component: () => import(/* webpackChunName: "login" */ './views/AutoLogin.vue')
  },

  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import(/* webpackChunName: "resetPassword" */ '../../views/users/template/forgetPassword.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunName: "logout" */ '../../views/users/template/logout.vue')
  },
  {
    path: '/users',
    name: 'UserIndex',
    component: () => import(/* webpackChunName: "UserIndex" */ './views/index.vue')
  },
  {
    path: '/user/add',
    name: 'UserAdd',
    component: () => import(/* webpackChunName: "UserAdd" */ '../../views/users/template/add.vue')
  },
  {
    path: '/user/scan',
    name: 'UserScan',
    component: () => import(/* webpackChunName: "UserScan" */ '../../views/users/template/scan.vue')
  },
  {
    path: '/user/view',
    name: 'UserView',
    component: () => import(/* webpackChunName: "UserView" */ '../../views/users/template/view.vue')
  },
  {
    path: '/user/edit',
    name: 'UserEdit',
    component: () => import(/* webpackChunName: "UserEdit" */ './views/edit.vue')
  }
]
module.exports = identiti2Routes